/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  IntegrationVersion,
  IntegrationVersion$inboundSchema,
} from "./integrationversion.js";

export type Integration = {
  packageDescription?: string | undefined;
  packageDescriptionRaw?: string | undefined;
  packageId: string;
  packageImageAssetId?: string | undefined;
  packageKeywords?: Array<string> | undefined;
  packageName: string;
  packageSummary: string;
  packageTitle: string;
  packageUrl?: string | undefined;
  toolNames: Array<string>;
  /**
   * The latest version of the integration
   */
  version: string;
  versionCreatedAt: Date;
  versions?: Array<IntegrationVersion> | undefined;
};

/** @internal */
export const Integration$inboundSchema: z.ZodMiniType<Integration, unknown> = z
  .pipe(
    z.object({
      package_description: z.optional(z.string()),
      package_description_raw: z.optional(z.string()),
      package_id: z.string(),
      package_image_asset_id: z.optional(z.string()),
      package_keywords: z.optional(z.array(z.string())),
      package_name: z.string(),
      package_summary: z.string(),
      package_title: z.string(),
      package_url: z.optional(z.string()),
      tool_names: z.array(z.string()),
      version: z.string(),
      version_created_at: z.pipe(
        z.iso.datetime({ offset: true }),
        z.transform(v => new Date(v)),
      ),
      versions: z.optional(z.array(IntegrationVersion$inboundSchema)),
    }),
    z.transform((v) => {
      return remap$(v, {
        "package_description": "packageDescription",
        "package_description_raw": "packageDescriptionRaw",
        "package_id": "packageId",
        "package_image_asset_id": "packageImageAssetId",
        "package_keywords": "packageKeywords",
        "package_name": "packageName",
        "package_summary": "packageSummary",
        "package_title": "packageTitle",
        "package_url": "packageUrl",
        "tool_names": "toolNames",
        "version_created_at": "versionCreatedAt",
      });
    }),
  );

export function integrationFromJSON(
  jsonString: string,
): SafeParseResult<Integration, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => Integration$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'Integration' from JSON`,
  );
}
